import { render, staticRenderFns } from "./EcommerceTotalCoins.vue?vue&type=template&id=ff2eb99c"
import script from "./EcommerceTotalCoins.vue?vue&type=script&lang=js"
export * from "./EcommerceTotalCoins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports